import {css} from '../theme/css'
import {scrollbarWidth} from './const'

export const classes = {
  noScroll: css`
    overflow: hidden;
    touch-action: none;
  `,
  scrollbarPadding: css`
    padding-right: ${scrollbarWidth};
  `,
}
